// Generated by BUCKLESCRIPT VERSION 4.0.14, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");

var Curry = require("bs-platform/lib/js/curry.js");

var Caml_obj = require("bs-platform/lib/js/caml_obj.js");

var Pervasives = require("bs-platform/lib/js/pervasives.js");

var Caml_option = require("bs-platform/lib/js/caml_option.js");

var Util$Rationale = require("./Util.js");

var Option$Rationale = require("./Option.js");

var Function$Rationale = require("./Function.js");

function head(xs) {
  var exit = 0;
  var a;

  try {
    a = List.hd(xs);
    exit = 1;
  } catch (exn) {
    return undefined;
  }

  if (exit === 1) {
    return Caml_option.some(a);
  }
}

function tail(xs) {
  var exit = 0;
  var a;

  try {
    a = List.tl(xs);
    exit = 1;
  } catch (exn) {
    return undefined;
  }

  if (exit === 1) {
    return a;
  }
}

function nth(i, xs) {
  var exit = 0;
  var a;

  try {
    a = List.nth(xs, i);
    exit = 1;
  } catch (exn) {
    return undefined;
  }

  if (exit === 1) {
    return Caml_option.some(a);
  }
}

function init(xs) {
  return Curry._2(Option$Rationale.$less$$great, tail(List.rev(xs)), List.rev);
}

function last(xs) {
  return head(List.rev(xs));
}

function any(pred, xs) {
  return List.fold_left(function (acc, v) {
    if (acc) {
      return acc;
    } else {
      return Curry._1(pred, v);
    }
  }, false, xs);
}

function append(a, xs) {
  return List.append(xs,
  /* :: */
  [a,
  /* [] */
  0]);
}

function concat(xs, ys) {
  return List.append(ys, xs);
}

function take(i, xs) {
  var _i = i;
  var _xs = xs;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var xs$1 = _xs;
    var i$1 = _i;

    if (i$1 <= 0 || !xs$1) {
      return acc;
    } else {
      _acc = append(xs$1[0], acc);
      _xs = xs$1[1];
      _i = i$1 - 1 | 0;
      continue;
    }
  }

  ;
}

function takeLast(i, xs) {
  return List.rev(take(i, List.rev(xs)));
}

function takeWhile(pred, xs) {
  var pred$1 = pred;
  var _xs = xs;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var xs$1 = _xs;

    if (xs$1) {
      var a = xs$1[0];

      var match = Curry._1(pred$1, a);

      if (match) {
        _acc = append(a, acc);
        _xs = xs$1[1];
        continue;
      } else {
        return acc;
      }
    } else {
      return acc;
    }
  }

  ;
}

function takeLastWhile(pred, xs) {
  return List.rev(takeWhile(pred, List.rev(xs)));
}

function drop(_i, _xs) {
  while (true) {
    var xs = _xs;
    var i = _i;

    if (xs) {
      if (i <= 0) {
        return xs;
      } else {
        _xs = xs[1];
        _i = i - 1 | 0;
        continue;
      }
    } else {
      return (
        /* [] */
        0
      );
    }
  }

  ;
}

function dropLast(i, xs) {
  return take(List.length(xs) - i | 0, xs);
}

function dropWhile(pred, _xs) {
  while (true) {
    var xs = _xs;

    if (xs) {
      var match = Curry._1(pred, xs[0]);

      if (match) {
        _xs = xs[1];
        continue;
      } else {
        return xs;
      }
    } else {
      return (
        /* [] */
        0
      );
    }
  }

  ;
}

function dropLastWhile(pred, xs) {
  return List.rev(dropWhile(pred, List.rev(xs)));
}

function dropRepeatsWith(pred, xs) {
  var pred$1 = pred;
  var _xs = xs;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var xs$1 = _xs;

    if (xs$1) {
      var b = xs$1[1];
      var a = xs$1[0];

      if (List.length(acc) === 0) {
        _acc = append(a, acc);
        _xs = b;
        continue;
      } else {
        var match = Option$Rationale.$$default(false, Curry._2(Option$Rationale.$less$$great, head(List.rev(acc)), Curry._1(pred$1, a)));

        if (match) {
          _xs = b;
          continue;
        } else {
          _acc = append(a, acc);
          _xs = b;
          continue;
        }
      }
    } else {
      return acc;
    }
  }

  ;
}

function dropRepeats(xs) {
  return dropRepeatsWith(Caml_obj.caml_equal, xs);
}

function splitAt(i, xs) {
  return (
    /* tuple */
    [take(i, xs), takeLast(List.length(xs) - i | 0, xs)]
  );
}

function adjust(f, i, xs) {
  var match = splitAt(i + 1 | 0, xs);
  var b = match[1];
  var a = match[0];

  if (i < 0 || i >= List.length(xs)) {
    return xs;
  } else if (a) {
    if (a[1]) {
      return Option$Rationale.$$default(xs, Curry._2(Option$Rationale.$less$$great, Curry._2(Option$Rationale.$great$great$eq, init(a), function (x) {
        return Curry._2(Option$Rationale.$less$$great, Curry._2(Option$Rationale.$less$$great, head(List.rev(a)), f), function (param) {
          return Function$Rationale.flip(append, x, param);
        });
      }), function (param) {
        return List.append(param, b);
      }));
    } else {
      return (
        /* :: */
        [Curry._1(f, a[0]), b]
      );
    }
  } else {
    return b;
  }
}

function aperture(i, xs) {
  var i$1 = i;
  var _xs = xs;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var xs$1 = _xs;

    if (xs$1 && List.length(xs$1) >= i$1) {
      _acc = append(take(i$1, xs$1), acc);
      _xs = xs$1[1];
      continue;
    } else {
      return acc;
    }
  }

  ;
}

function containsWith(f) {
  return function (param) {
    return List.exists(f, param);
  };
}

function contains(x) {
  return function (param) {
    return List.exists(function (param) {
      return Util$Rationale.eq(x, param);
    }, param);
  };
}

function endsWith(a, xs) {
  return Option$Rationale.$$default(false, Curry._2(Option$Rationale.$less$$great, head(List.rev(xs)), function (param) {
    return Util$Rationale.eq(a, param);
  }));
}

function find(pred, xs) {
  var exit = 0;
  var a;

  try {
    a = List.find(pred, xs);
    exit = 1;
  } catch (exn) {
    return undefined;
  }

  if (exit === 1) {
    return Caml_option.some(a);
  }
}

function findIndex(pred, xs) {
  var pred$1 = pred;
  var _xs = xs;
  var _i = 0;

  while (true) {
    var i = _i;
    var xs$1 = _xs;

    if (xs$1) {
      var match = Curry._1(pred$1, xs$1[0]);

      if (match) {
        return i;
      } else {
        _i = i + 1 | 0;
        _xs = xs$1[1];
        continue;
      }
    } else {
      return undefined;
    }
  }

  ;
}

function findLast(pred, xs) {
  return find(pred, List.rev(xs));
}

function findLastIndex(pred, xs) {
  var match = findIndex(pred, List.rev(xs));

  if (match !== undefined) {
    return (List.length(xs) - match | 0) - 1 | 0;
  }
}

function groupWith(pred, xs) {
  var pred$1 = pred;
  var _n = 0;
  var _xs = xs;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var xs$1 = _xs;
    var n = _n;

    if (xs$1) {
      if (xs$1[1]) {
        if (n > List.length(xs$1)) {
          return append(xs$1, acc);
        } else {
          var match = splitAt(n + 1 | 0, xs$1);
          var x1 = match[1];
          var x0 = match[0];
          var match$1 = Option$Rationale.$$default(true, Curry._2(Option$Rationale.Infix[
          /* <*> */
          2], Curry._2(Option$Rationale.Infix[
          /* <*> */
          2], pred$1, head(List.rev(x0))), head(x1)));

          if (match$1) {
            _n = n + 1 | 0;
            continue;
          } else {
            _acc = append(x0, acc);
            _xs = x1;
            _n = 0;
            continue;
          }
        }
      } else {
        return append(
        /* :: */
        [xs$1[0],
        /* [] */
        0], acc);
      }
    } else {
      var match$2 = List.length(acc) === 0;

      if (match$2) {
        return (
          /* :: */
          [
          /* [] */
          0,
          /* [] */
          0]
        );
      } else {
        return acc;
      }
    }
  }

  ;
}

function indexOf(a, xs) {
  return findIndex(function (x) {
    return Caml_obj.caml_equal(a, x);
  }, xs);
}

function insert(i, x, xs) {
  var match = splitAt(i, xs);
  var ys = append(x, match[0]);
  return List.append(ys, match[1]);
}

function insertAll(i, xs, ys) {
  var match = splitAt(i, ys);
  var ys$1 = List.append(match[0], xs);
  return List.append(ys$1, match[1]);
}

function intersperse(a, xs) {
  return List.fold_left(function (acc, v) {
    var match = List.length(acc) > 0;

    if (match) {
      return append(v, append(a, acc));
    } else {
      return (
        /* :: */
        [v,
        /* [] */
        0]
      );
    }
  },
  /* [] */
  0, xs);
}

function join(j) {
  return function (param) {
    return List.fold_left(function (acc, v) {
      var match = acc.length === 0;

      if (match) {
        return v;
      } else {
        return acc + (j + v);
      }
    }, "", param);
  };
}

function lastIndexOf(a, xs) {
  var match = indexOf(a, List.rev(xs));

  if (match !== undefined) {
    return (List.length(xs) - match | 0) - 1 | 0;
  }
}

function none(pred, xs) {
  return !List.exists(pred, xs);
}

function partition(pred, xs) {
  return (
    /* tuple */
    [List.filter(pred)(xs), List.filter(function (x) {
      return !Curry._1(pred, x);
    })(xs)]
  );
}

function range(inc, s, e) {
  var inc$1 = inc;
  var s$1 = s;
  var e$1 = e;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var match = List.rev(acc);

    if (match) {
      var a = match[0];
      var match$1 = Caml_obj.caml_greaterthan(Curry._1(inc$1, a), e$1);

      if (match$1) {
        return acc;
      } else {
        _acc = append(Curry._1(inc$1, a), acc);
        continue;
      }
    } else {
      _acc =
      /* :: */
      [s$1,
      /* [] */
      0];
      continue;
    }
  }

  ;
}

function rangeInt(step) {
  return function (param, param$1) {
    return range(function (x) {
      return x + step | 0;
    }, param, param$1);
  };
}

function rangeFloat(step) {
  return function (param, param$1) {
    return range(function (x) {
      return x + step;
    }, param, param$1);
  };
}

function reduceWhile(pred, f, x, xs) {
  return List.fold_left(function (acc, v) {
    if (acc[0]) {
      var a = acc[1];

      var match = Curry._2(pred, a, v);

      if (match) {
        return (
          /* tuple */
          [true, Curry._2(f, a, v)]
        );
      } else {
        return (
          /* tuple */
          [false, a]
        );
      }
    } else {
      return acc;
    }
  },
  /* tuple */
  [true, x], xs)[1];
}

function reject(pred) {
  return List.filter(function (x) {
    return !Curry._1(pred, x);
  });
}

function remove(i, n, xs) {
  var match = splitAt(i, xs);
  return Pervasives.$at(match[0], drop(n, match[1]));
}

function repeat(a, n) {
  var a$1 = a;
  var _n = n;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var n$1 = _n;

    if (n$1 !== 0) {
      _acc = append(a$1, acc);
      _n = n$1 - 1 | 0;
      continue;
    } else {
      return acc;
    }
  }

  ;
}

function scan(f, i) {
  var partial_arg =
  /* :: */
  [i,
  /* [] */
  0];
  return function (param) {
    return List.fold_left(function (acc, v) {
      return Option$Rationale.$$default(
      /* [] */
      0, Curry._2(Option$Rationale.$less$$great, Curry._2(Option$Rationale.$less$$great, head(List.rev(acc)), function (param) {
        return Function$Rationale.flip(f, v, param);
      }), function (param) {
        return Function$Rationale.flip(append, acc, param);
      }));
    }, partial_arg, param);
  };
}

function slice(a, b, xs) {
  return splitAt(b, splitAt(a, xs)[1])[0];
}

function splitEvery(n, xs) {
  var n$1 = n;
  var _xs = xs;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var xs$1 = _xs;

    if (xs$1) {
      _acc = append(take(n$1, xs$1), acc);
      _xs = drop(n$1, xs$1);
      continue;
    } else {
      return acc;
    }
  }

  ;
}

function splitWhen(pred, xs) {
  var match = findIndex(pred, xs);

  if (match !== undefined) {
    return splitAt(match, xs);
  } else {
    return (
      /* tuple */
      [xs,
      /* [] */
      0]
    );
  }
}

function startsWith(x, xs) {
  var match = head(xs);

  if (match !== undefined) {
    return Caml_obj.caml_equal(Caml_option.valFromOption(match), x);
  } else {
    return false;
  }
}

function times(f, n) {
  var f$1 = f;
  var n$1 = n;
  var _i = 0;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var i = _i;

    if (i < n$1) {
      _acc = append(Curry._1(f$1, i), acc);
      _i = i + 1 | 0;
      continue;
    } else {
      return acc;
    }
  }

  ;
}

function uniqWithBy(eq, f, xs) {
  return List.fold_left(function (param, v) {
    var tacc = param[1];
    var acc = param[0];

    var partial_arg = Curry._1(eq, Curry._1(f, v));

    var match = function (param) {
      return List.exists(partial_arg, param);
    }(tacc);

    if (match) {
      return (
        /* tuple */
        [acc, tacc]
      );
    } else {
      return (
        /* tuple */
        [append(v, acc), append(Curry._1(f, v), tacc)]
      );
    }
  },
  /* tuple */
  [
  /* [] */
  0,
  /* [] */
  0], xs)[0];
}

function uniqBy(f, xs) {
  return uniqWithBy(Util$Rationale.eq, f, xs);
}

function uniqWith(eq, xs) {
  return uniqWithBy(eq, Function$Rationale.identity, xs);
}

function uniq(xs) {
  return uniqWithBy(Util$Rationale.eq, Function$Rationale.identity, xs);
}

function unionWith(f, xs, ys) {
  var xs$1 = List.append(xs, ys);
  return uniqWithBy(f, Function$Rationale.identity, xs$1);
}

function union(xs, ys) {
  var xs$1 = List.append(xs, ys);
  return uniqWithBy(Util$Rationale.eq, Function$Rationale.identity, xs$1);
}

function update(x, i, xs) {
  return adjust(function (param) {
    return Function$Rationale.always(x, param);
  }, i, xs);
}

function without(exclude, xs) {
  var pred = function pred(x) {
    return List.exists(function (param) {
      return Util$Rationale.eq(x, param);
    }, exclude);
  };

  return List.filter(function (x) {
    return !Curry._1(pred, x);
  })(xs);
}

function zipWith(f, xs, ys) {
  var f$1 = f;
  var _xs = xs;
  var _ys = ys;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var ys$1 = _ys;
    var xs$1 = _xs;

    if (xs$1 && ys$1) {
      _acc = append(Curry._2(f$1, xs$1[0], ys$1[0]), acc);
      _ys = ys$1[1];
      _xs = xs$1[1];
      continue;
    } else {
      return acc;
    }
  }

  ;
}

function loop(f, _xs, ys, _acc) {
  while (true) {
    var acc = _acc;
    var xs = _xs;

    if (xs) {
      var b = xs[1];
      var a = xs[0];

      var partial_arg = Curry._1(f, a);

      var match = function (partial_arg) {
        return function (param) {
          return List.exists(partial_arg, param);
        };
      }(partial_arg)(ys);

      if (match) {
        _xs = b;
        continue;
      } else {
        _acc = append(a, acc);
        _xs = b;
        continue;
      }
    } else {
      return acc;
    }
  }

  ;
}

function differenceWith(f, xs, ys) {
  return Pervasives.$at(loop(f, xs, ys,
  /* [] */
  0), loop(f, ys, xs,
  /* [] */
  0));
}

function difference(xs, ys) {
  return differenceWith(Util$Rationale.eq, xs, ys);
}

function intersection(xs, ys) {
  var _xs = xs;
  var ys$1 = ys;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var xs$1 = _xs;

    if (xs$1) {
      var b = xs$1[1];
      var a = xs$1[0];
      var match = List.exists(function (a) {
        return function (param) {
          return Util$Rationale.eq(a, param);
        };
      }(a), ys$1);

      if (match) {
        _acc = append(a, acc);
        _xs = b;
        continue;
      } else {
        _xs = b;
        continue;
      }
    } else {
      return acc;
    }
  }

  ;
}

function zip(xs, ys) {
  var _xs = xs;
  var _ys = ys;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var ys$1 = _ys;
    var xs$1 = _xs;

    if (xs$1 && ys$1) {
      _acc = append(
      /* tuple */
      [xs$1[0], ys$1[0]], acc);
      _ys = ys$1[1];
      _xs = xs$1[1];
      continue;
    } else {
      return acc;
    }
  }

  ;
}

function fold_lefti(f, init, xs) {
  var _i = 0;
  var f$1 = f;
  var _acc = init;
  var _xs = xs;

  while (true) {
    var xs$1 = _xs;
    var acc = _acc;
    var i = _i;

    if (xs$1) {
      _xs = xs$1[1];
      _acc = Curry._3(f$1, acc, i, xs$1[0]);
      _i = i + 1 | 0;
      continue;
    } else {
      return acc;
    }
  }

  ;
}

function xis(xs) {
  return fold_lefti(function (acc, i, a) {
    return (
      /* :: */
      [
      /* tuple */
      [i, a], acc]
    );
  },
  /* [] */
  0, xs);
}

function fold_righti(f, init, xs) {
  return List.fold_left(function (acc, param) {
    return Curry._3(f, acc, param[0], param[1]);
  }, init, xis(xs));
}

function filteri(pred, xs) {
  var pred$1 = pred;
  var _xs = xs;
  var _i = 0;
  var _acc =
  /* [] */
  0;

  while (true) {
    var acc = _acc;
    var i = _i;
    var xs$1 = _xs;

    if (xs$1) {
      var b = xs$1[1];
      var a = xs$1[0];

      var match = Curry._2(pred$1, i, a);

      if (match) {
        _acc = append(a, acc);
        _i = i + 1 | 0;
        _xs = b;
        continue;
      } else {
        _i = i + 1 | 0;
        _xs = b;
        continue;
      }
    } else {
      return acc;
    }
  }

  ;
}

function filter_map(pred, f, xs) {
  return List.fold_left(function (acc, x) {
    var match = Curry._1(pred, x);

    if (match) {
      return append(Curry._1(f, x), acc);
    } else {
      return acc;
    }
  },
  /* [] */
  0, xs);
}

function filter_mapi(pred, f, xs) {
  return fold_lefti(function (acc, i, a) {
    var match = Curry._2(pred, i, a);

    if (match) {
      return append(Curry._2(f, i, a), acc);
    } else {
      return acc;
    }
  },
  /* [] */
  0, xs);
}

function pure(a) {
  return (
    /* :: */
    [a,
    /* [] */
    0]
  );
}

function create(f, n) {
  if (n < 0) {
    return (
      /* [] */
      0
    );
  } else {
    var _n = n;
    var _acc =
    /* [] */
    0;

    while (true) {
      var acc = _acc;
      var n$1 = _n;
      var match = n$1 === 0;

      if (match) {
        return acc;
      } else {
        _acc =
        /* :: */
        [Curry._1(f, n$1 - 1 | 0), acc];
        _n = n$1 - 1 | 0;
        continue;
      }
    }

    ;
  }
}

function filter_opt(xs) {
  var loop = function loop(_l, _acc) {
    while (true) {
      var acc = _acc;
      var l = _l;

      if (l) {
        var tl = l[1];
        var hd = l[0];

        if (hd !== undefined) {
          _acc =
          /* :: */
          [Caml_option.valFromOption(hd), acc];
          _l = tl;
          continue;
        } else {
          _l = tl;
          continue;
        }
      } else {
        return acc;
      }
    }

    ;
  };

  return List.rev(loop(xs,
  /* [] */
  0));
}

function reduce(f, xs) {
  if (xs) {
    return Caml_option.some(List.fold_left(f, xs[0], xs[1]));
  }
}

function merge(compare, xs, ys) {
  var _acc =
  /* [] */
  0;
  var _xs = xs;
  var _ys = ys;

  while (true) {
    var ys$1 = _ys;
    var xs$1 = _xs;
    var acc = _acc;

    if (xs$1) {
      if (ys$1) {
        var h2 = ys$1[0];
        var h1 = xs$1[0];
        var match = Curry._2(compare, h1, h2) <= 0;

        if (match) {
          _xs = xs$1[1];
          _acc =
          /* :: */
          [h1, acc];
          continue;
        } else {
          _ys = ys$1[1];
          _acc =
          /* :: */
          [h2, acc];
          continue;
        }
      } else {
        return List.rev_append(acc, xs$1);
      }
    } else {
      return List.rev_append(acc, ys$1);
    }
  }

  ;
}

exports.head = head;
exports.tail = tail;
exports.nth = nth;
exports.init = init;
exports.last = last;
exports.any = any;
exports.append = append;
exports.concat = concat;
exports.take = take;
exports.takeLast = takeLast;
exports.takeWhile = takeWhile;
exports.takeLastWhile = takeLastWhile;
exports.drop = drop;
exports.dropLast = dropLast;
exports.dropLastWhile = dropLastWhile;
exports.dropRepeatsWith = dropRepeatsWith;
exports.dropRepeats = dropRepeats;
exports.dropWhile = dropWhile;
exports.splitAt = splitAt;
exports.adjust = adjust;
exports.aperture = aperture;
exports.containsWith = containsWith;
exports.contains = contains;
exports.endsWith = endsWith;
exports.find = find;
exports.findIndex = findIndex;
exports.findLast = findLast;
exports.findLastIndex = findLastIndex;
exports.groupWith = groupWith;
exports.indexOf = indexOf;
exports.insert = insert;
exports.insertAll = insertAll;
exports.intersperse = intersperse;
exports.join = join;
exports.lastIndexOf = lastIndexOf;
exports.none = none;
exports.partition = partition;
exports.range = range;
exports.rangeInt = rangeInt;
exports.rangeFloat = rangeFloat;
exports.reduceWhile = reduceWhile;
exports.reject = reject;
exports.remove = remove;
exports.repeat = repeat;
exports.scan = scan;
exports.slice = slice;
exports.splitEvery = splitEvery;
exports.splitWhen = splitWhen;
exports.startsWith = startsWith;
exports.times = times;
exports.uniqWithBy = uniqWithBy;
exports.uniqBy = uniqBy;
exports.uniqWith = uniqWith;
exports.uniq = uniq;
exports.unionWith = unionWith;
exports.union = union;
exports.update = update;
exports.without = without;
exports.zipWith = zipWith;
exports.differenceWith = differenceWith;
exports.difference = difference;
exports.intersection = intersection;
exports.zip = zip;
exports.pure = pure;
exports.fold_lefti = fold_lefti;
exports.fold_righti = fold_righti;
exports.filteri = filteri;
exports.filter_map = filter_map;
exports.filter_mapi = filter_mapi;
exports.create = create;
exports.filter_opt = filter_opt;
exports.reduce = reduce;
exports.merge = merge;
/* Option-Rationale Not a pure module */